import { useTranslate } from "@similarweb/i18n-provider";
import type { ActivationContractGoogleAnalyticsGoogleMappingState } from "@similarweb/pro-api-client";
import { AlertBanner } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { useActivationGaMappingState } from "./hooks";
import { GaConnectTexts } from "./texts";

const mappingStateKey = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Disabled: GaConnectTexts.gaMappingDisabledText,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Faulty: GaConnectTexts.gaMappingFaultText,
} satisfies Record<Exclude<ActivationContractGoogleAnalyticsGoogleMappingState, "Active">, string>;

interface IGaMappingWarningBannerProps {
    activationId: string;
    dataAutomationPrefix?: string;
    isGaSource?: boolean;
    withTopPadding?: boolean;
}

export const GaMappingWarningBanner = ({
    activationId,
    dataAutomationPrefix = "ga-mapping-warning-banner",
    isGaSource,
    withTopPadding,
}: IGaMappingWarningBannerProps) => {
    const { translate } = useTranslate();
    const { isMappingLoading, mappingState } = useActivationGaMappingState(activationId, {
        shouldIgnoreResourceNotFoundError: true,
    });

    if (isMappingLoading || !mappingState || mappingState === "Active" || (!isGaSource && mappingState === "Faulty")) {
        return null;
    }

    const descriptionKey = mappingStateKey[mappingState];

    const content = (
        <AlertBanner
            variant="info"
            data-automation={`${dataAutomationPrefix}-${mappingState}`}
            shadowed
        >
            <AlertBanner.Image />
            <AlertBanner.Description>{translate(descriptionKey)}</AlertBanner.Description>
        </AlertBanner>
    );

    // edge case for project page components alignment
    if (withTopPadding) {
        return (
            <Box
                paddingY="24px 0"
                width="100%"
            >
                {content}
            </Box>
        );
    }

    return content;
};
